/**
 * Helper utility to safely resolve Contentful URLs.
 * Contentful often provides protocol-relative URLs (starting with //).
 * This function ensures they are strictly formatted with https protocol.
 */
export function resolveUrl(url: string | undefined | null): string {
  if (!url) return '';
  return url.startsWith('//') ? `https:${url}` : url;
}

/**
 * Utility function to determine if a file is an SVG based on its filename or content type.
 * This is important for rendering decisions, as SVGs may require different handling than other image types.
 *
 * @param fileName - The name of the file, which may include the extension.
 * @param contentType - The MIME type of the file, which can indicate if it's an SVG.
 * @returns A boolean indicating whether the file is an SVG.
 */
export function isSvgFile(fileName?: string, contentType?: string) {
  if (contentType === 'image/svg+xml') return true;
  return Boolean(fileName && fileName.toLowerCase().endsWith('.svg'));
}
